<template>
	<router-link :to="route" tag="li">
		<a>
			<span class="iconfont" :class="`icon-${icon}`" v-if="!!icon"></span>
			<span>{{label}}</span>
			<slot name="label"></slot>
		</a>
		<slot name="menu"></slot>
	</router-link>
</template>

<script>
	export default {
		props: {
			label: String,
			url: String,
			icon: String,
			route: {
				type: Object,
				default: function() {
					return {}
				}
			}
		},
		data() {
			return {
				active: false
			}
		},
		methods: {
		},
		mounted: function() {
			this.$nextTick(function() {})
		},
		computed: {
			setIcon(){
				return this.icon&&`icon-${icon}`
			}
		}

	}
</script>
<style lang="less">

</style>


// WEBPACK FOOTER //
// smenuli.vue?23a26c07